export interface MovieItem {
  id: string;
  title: string;
  type: "movie" | "tv";
  poster: string;
  year: number;
  rating: number;
  region: string;
  genres: string[];
  director: string;
  actors: string[];
  language: string;
  synopsis: string;
  updateTime: string;
  episodes: number;
  views: number;
  tags: string[];
  specials: string[];
}

export const movies: MovieItem[] = [
  {
    id: "m001",
    title: "星际迷航：黎明边缘",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20silhouette%20before%20a%20giant%20glowing%20planet%2C%20deep%20navy%20blue%20and%20orange%20teal%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20atmospheric%20composition%2C%20no%20text&width=600&height=900&seq=qx-poster-m001&orientation=portrait",
    year: 2026,
    rating: 9.1,
    region: "美国",
    genres: ["科幻", "冒险"],
    director: "迈克尔·陈",
    actors: ["李明轩", "艾玛·斯通", "张伟"],
    language: "英语",
    synopsis: "在人类星际殖民的第三个世纪，一艘失联百年的探索舰突然从虫洞深处发出求救信号。年轻的舰长杰克带领一支临时拼凑的船员小队穿越危险星域，却发现信号背后隐藏着一个足以改写人类命运的惊人真相。",
    updateTime: "2026-10-12",
    episodes: 1,
    views: 328000,
    tags: ["太空", "虫洞", "高口碑"],
    specials: ["s1", "s3"],
  },
  {
    id: "m002",
    title: "暗涌",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20a%20rain%20soaked%20night%20city%20street%20with%20a%20lone%20detective%20under%20a%20streetlight%2C%20deep%20navy%20and%20orange%20neon%20color%20grading%2C%20dramatic%20moody%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m002&orientation=portrait",
    year: 2025,
    rating: 8.6,
    region: "中国香港",
    genres: ["犯罪", "悬疑"],
    director: "杜峰",
    actors: ["刘青云", "古天乐", "周迅"],
    language: "粤语",
    synopsis: "一桩看似普通的走私案，牵出横跨三地的地下洗钱网络。卧底多年的警官在身份即将暴露的绝境中，必须在信任与背叛之间做出抉择。",
    updateTime: "2026-10-11",
    episodes: 1,
    views: 276000,
    tags: ["警匪", "卧底", "港片"],
    specials: ["s2", "s4"],
  },
  {
    id: "m003",
    title: "光年之外",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20space%20movie%20poster%20of%20a%20spaceship%20flying%20through%20a%20colorful%20nebula%20with%20distant%20stars%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grading%2C%20epic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m003&orientation=portrait",
    year: 2026,
    rating: 8.9,
    region: "美国",
    genres: ["科幻", "剧情"],
    director: "克里斯托弗·李",
    actors: ["马修·麦康纳", "安妮·海瑟薇"],
    language: "英语",
    synopsis: "当地球资源枯竭，一支探险队穿越虫洞寻找人类新的家园。面对时间与空间的扭曲，跨越光年的亲情成为他们唯一的信念支撑。",
    updateTime: "2026-10-09",
    episodes: 1,
    views: 412000,
    tags: ["硬科幻", "亲情", "催泪"],
    specials: ["s1"],
  },
  {
    id: "m004",
    title: "最后一班地铁",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20movie%20poster%20of%20two%20silhouettes%20on%20an%20empty%20subway%20platform%20at%20night%2C%20soft%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20moody%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m004&orientation=portrait",
    year: 2024,
    rating: 8.2,
    region: "韩国",
    genres: ["爱情", "剧情"],
    director: "朴赞旭",
    actors: ["金秀贤", "孙艺珍"],
    language: "韩语",
    synopsis: "每天深夜同一班地铁上，两个陌生人因一次遗失的日记本而相识。他们彼此治愈，却各自背负着无法言说的伤痛。",
    updateTime: "2026-10-08",
    episodes: 1,
    views: 198000,
    tags: ["纯爱", "治愈", "都市"],
    specials: ["s2"],
  },
  {
    id: "m005",
    title: "深海回声",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20horror%20movie%20poster%20of%20a%20deep%20sea%20submersible%20diving%20into%20dark%20ocean%20depths%20with%20eerie%20light%2C%20deep%20navy%20and%20teal%20orange%20color%20grading%2C%20suspenseful%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m005&orientation=portrait",
    year: 2025,
    rating: 7.8,
    region: "美国",
    genres: ["惊悚", "悬疑"],
    director: "詹姆斯·王",
    actors: ["布莱德利·库珀", "杰西卡·查斯坦"],
    language: "英语",
    synopsis: "一支深海科考队在马里亚纳海沟深处捕捉到一段诡异的声波信号，随着下潜深度的增加，船员们开始一个接一个地陷入疯狂。",
    updateTime: "2026-10-07",
    episodes: 1,
    views: 156000,
    tags: ["深海", "惊悚", "密室"],
    specials: ["s4"],
  },
  {
    id: "m006",
    title: "荒漠孤骑",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20western%20movie%20poster%20of%20a%20lone%20cowboy%20riding%20a%20horse%20across%20a%20vast%20orange%20desert%20at%20sunset%2C%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20epic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m006&orientation=portrait",
    year: 2024,
    rating: 8.0,
    region: "美国",
    genres: ["西部", "动作"],
    director: "凯文·科斯特",
    actors: ["丹泽尔·华盛顿", "克里斯·派恩"],
    language: "英语",
    synopsis: "一个背负血仇的赏金猎人穿越荒芜的边境小镇，为复仇而来，却在途中被卷入一场关乎整个小镇存亡的阴谋。",
    updateTime: "2026-10-05",
    episodes: 1,
    views: 142000,
    tags: ["西部", "复仇", "硬汉"],
    specials: ["s3"],
  },
  {
    id: "m007",
    title: "电子梦境",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20cyberpunk%20movie%20poster%20of%20a%20futuristic%20neon%20cityscape%20with%20holographic%20data%20streams%2C%20deep%20navy%20blue%20and%20vivid%20orange%20neon%20color%20grading%2C%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m007&orientation=portrait",
    year: 2026,
    rating: 8.4,
    region: "日本",
    genres: ["科幻", "动画"],
    director: "新海诚",
    actors: ["花泽香菜", "神木隆之介"],
    language: "日语",
    synopsis: "在一个记忆可以被数字化的未来都市，一名少女黑客发现自己记忆中的世界竟是被人为构建的虚拟牢笼，为寻回真实她踏上逃亡之路。",
    updateTime: "2026-10-04",
    episodes: 1,
    views: 233000,
    tags: ["赛博朋克", "动画", "烧脑"],
    specials: ["s1", "s5"],
  },
  {
    id: "m008",
    title: "白夜行旅",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20drama%20movie%20poster%20of%20a%20solitary%20traveler%20walking%20through%20a%20foggy%20european%20town%20at%20dawn%2C%20muted%20deep%20navy%20and%20soft%20orange%20color%20grading%2C%20melancholic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m008&orientation=portrait",
    year: 2024,
    rating: 8.3,
    region: "法国",
    genres: ["剧情", "文艺"],
    director: "吕克·贝松",
    actors: ["蕾雅·赛杜", "加斯帕德·尤利尔"],
    language: "法语",
    synopsis: "一位中年作家在失去挚爱后独自踏上横跨欧洲的旅途，在陌生城市的晨光与夜色中，他重新学会与自己的悲伤和解。",
    updateTime: "2026-10-03",
    episodes: 1,
    views: 118000,
    tags: ["文艺", "公路", "治愈"],
    specials: ["s2"],
  },
  {
    id: "m009",
    title: "功夫小子传",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20martial%20arts%20comedy%20movie%20poster%20of%20a%20young%20kung%20fu%20apprentice%20in%20traditional%20training%20courtyard%2C%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20dynamic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m009&orientation=portrait",
    year: 2025,
    rating: 7.6,
    region: "中国大陆",
    genres: ["喜剧", "动作"],
    director: "王宝强",
    actors: ["沈腾", "马丽"],
    language: "汉语普通话",
    synopsis: "一个来自小镇的平凡少年怀揣武侠梦闯荡大城市，误打误撞进入一家濒临倒闭的武馆，从此展开一段爆笑又热血的成长旅程。",
    updateTime: "2026-10-02",
    episodes: 1,
    views: 264000,
    tags: ["功夫", "喜剧", "合家欢"],
    specials: ["s5"],
  },
  {
    id: "m010",
    title: "极地营救",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20action%20adventure%20movie%20poster%20of%20a%20rescue%20team%20trekking%20across%20a%20snowy%20arctic%20wasteland%2C%20cool%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20epic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m010&orientation=portrait",
    year: 2025,
    rating: 8.1,
    region: "美国",
    genres: ["动作", "冒险"],
    director: "罗兰·艾默里奇",
    actors: ["汤姆·哈迪", "查理兹·塞隆"],
    language: "英语",
    synopsis: "一场突如其来的极地风暴摧毁了北极科考站，一支救援小队深入零下六十度的冰原，与时间赛跑营救被困的科学家。",
    updateTime: "2026-09-29",
    episodes: 1,
    views: 189000,
    tags: ["灾难", "救援", "冒险"],
    specials: ["s3"],
  },
  {
    id: "m011",
    title: "童年夏天",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20anime%20family%20movie%20poster%20of%20children%20running%20through%20a%20sunny%20rice%20field%20village%20in%20summer%2C%20warm%20orange%20golden%20and%20deep%20navy%20color%20grading%2C%20nostalgic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m011&orientation=portrait",
    year: 2023,
    rating: 8.7,
    region: "日本",
    genres: ["动画", "家庭"],
    director: "宫崎吾朗",
    actors: ["芦田爱菜", "桥本环奈"],
    language: "日语",
    synopsis: "在城市长大的少年被送到乡下祖母家度过暑假，在蝉鸣与星空之间，他找回了被遗忘的纯真，也读懂了亲情的重量。",
    updateTime: "2026-09-27",
    episodes: 1,
    views: 205000,
    tags: ["治愈", "童年", "催泪"],
    specials: ["s2", "s5"],
  },
  {
    id: "m012",
    title: "未来契约",
    type: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20human%20hand%20touching%20a%20glowing%20holographic%20interface%2C%20deep%20navy%20blue%20and%20vivid%20orange%20color%20grading%2C%20futuristic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-m012&orientation=portrait",
    year: 2026,
    rating: 8.5,
    region: "美国",
    genres: ["科幻", "悬疑"],
    director: "丹尼斯·维伦纽瓦",
    actors: ["瑞恩·高斯林", "赞达亚"],
    language: "英语",
    synopsis: "在一家掌控全球记忆备份的科技公司，一名程序员偶然发现系统深处的异常数据，揭开了一场关于人类自由意志的惊天骗局。",
    updateTime: "2026-09-25",
    episodes: 1,
    views: 301000,
    tags: ["科幻", "反乌托邦", "烧脑"],
    specials: ["s1", "s4"],
  },
  {
    id: "t001",
    title: "长安夜行录",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20historical%20drama%20poster%20of%20ancient%20tang%20dynasty%20capital%20city%20at%20night%20with%20lanterns%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20atmospheric%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t001&orientation=portrait",
    year: 2025,
    rating: 9.0,
    region: "中国大陆",
    genres: ["古装", "悬疑"],
    director: "曹盾",
    actors: ["雷佳音", "易烊千玺", "热依扎"],
    language: "汉语普通话",
    synopsis: "大唐天宝年间，长安城接连发生离奇命案。一名被贬的捕快与一位神秘的算学奇才联手，在十二个时辰内破解即将撼动整座都城阴谋。",
    updateTime: "2026-10-13",
    episodes: 36,
    views: 892000,
    tags: ["古装", "权谋", "高能"],
    specials: ["s1", "s3"],
  },
  {
    id: "t002",
    title: "雾都疑影",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20british%20detective%20series%20poster%20of%20a%20foggy%20victorian%20london%20street%20with%20gas%20lamps%2C%20muted%20deep%20navy%20and%20orange%20color%20grading%2C%20mysterious%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t002&orientation=portrait",
    year: 2025,
    rating: 8.8,
    region: "英国",
    genres: ["悬疑", "犯罪"],
    director: "史蒂文·奈特",
    actors: ["本尼迪克特·康伯巴奇", "凯拉·奈特莉"],
    language: "英语",
    synopsis: "维多利亚时代的伦敦，一位天才侦探与一名女法医携手侦破一桩桩看似超自然实则有迹可循的连环谜案。",
    updateTime: "2026-10-12",
    episodes: 24,
    views: 645000,
    tags: ["推理", "英剧", "高智商"],
    specials: ["s4"],
  },
  {
    id: "t003",
    title: "山海纪",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20fantasy%20drama%20poster%20of%20a%20warrior%20before%20a%20giant%20mythical%20beast%20in%20misty%20mountains%2C%20deep%20navy%20and%20fiery%20orange%20color%20grading%2C%20epic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t003&orientation=portrait",
    year: 2026,
    rating: 8.6,
    region: "中国大陆",
    genres: ["奇幻", "古装"],
    director: "乌尔善",
    actors: ["黄渤", "费翔", "娜然"],
    language: "汉语普通话",
    synopsis: "上古山海世界，人族少年意外觉醒神兽血脉，为守护苍生踏上寻找山海经秘境之路，途中结识挚友也直面宿命。",
    updateTime: "2026-10-13",
    episodes: 42,
    views: 1024000,
    tags: ["神话", "热血", "大制作"],
    specials: ["s1", "s3"],
  },
  {
    id: "t004",
    title: "追风者",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20modern%20drama%20poster%20of%20a%20young%20man%20on%20a%20rooftop%20overlooking%20a%20city%20skyline%20at%20dusk%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20inspiring%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t004&orientation=portrait",
    year: 2025,
    rating: 8.5,
    region: "中国大陆",
    genres: ["剧情", "青春"],
    director: "张开宙",
    actors: ["白宇帆", "张若昀", "关晓彤"],
    language: "汉语普通话",
    synopsis: "一群怀揣梦想的年轻人在城市中拼搏奋斗，面对现实的考验与命运的转折，他们选择迎风而上，书写属于自己的青春答卷。",
    updateTime: "2026-10-11",
    episodes: 40,
    views: 578000,
    tags: ["青春", "励志", "现实"],
    specials: ["s5"],
  },
  {
    id: "t005",
    title: "樱花下的约定",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20japanese%20romance%20drama%20poster%20of%20a%20couple%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20dreamy%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t005&orientation=portrait",
    year: 2024,
    rating: 8.3,
    region: "日本",
    genres: ["爱情", "青春"],
    director: "岩井俊二",
    actors: ["广濑铃", "山崎贤人"],
    language: "日语",
    synopsis: "中学时代定下约定的两人在多年后于故乡的樱花树下重逢，曾经的青涩心动与未说出口的话语，在这个春天重新被拾起。",
    updateTime: "2026-10-10",
    episodes: 16,
    views: 421000,
    tags: ["纯爱", "日剧", "治愈"],
    specials: ["s2"],
  },
  {
    id: "t006",
    title: "无声证人",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20korean%20crime%20drama%20poster%20of%20a%20forensic%20investigator%20examining%20evidence%20in%20a%20dark%20lab%2C%20deep%20navy%20and%20cold%20orange%20color%20grading%2C%20tense%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t006&orientation=portrait",
    year: 2025,
    rating: 8.7,
    region: "韩国",
    genres: ["犯罪", "悬疑"],
    director: "朴勋政",
    actors: ["李准基", "金高银"],
    language: "韩语",
    synopsis: "一位能从现场蛛丝马迹中还原真相的女法医，与一名直觉敏锐的重案组刑警搭档，在无声的证据中寻找正义的回响。",
    updateTime: "2026-10-12",
    episodes: 20,
    views: 512000,
    tags: ["刑侦", "韩剧", "烧脑"],
    specials: ["s4"],
  },
  {
    id: "t007",
    title: "时间管理局",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20tv%20series%20poster%20of%20a%20giant%20clock%20mechanism%20surrounded%20by%20glowing%20time%20rifts%2C%20deep%20navy%20blue%20and%20orange%20color%20grading%2C%20futuristic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t007&orientation=portrait",
    year: 2026,
    rating: 8.4,
    region: "美国",
    genres: ["科幻", "悬疑"],
    director: "乔纳森·诺兰",
    actors: ["汤姆·希德勒斯顿", "艾米莉亚·克拉克"],
    language: "英语",
    synopsis: "在负责维护时间线稳定的秘密机构中，一名新晋特工发现组织内部早已被渗透，而他每一次的时空修正都在改变自己的过去。",
    updateTime: "2026-10-13",
    episodes: 30,
    views: 688000,
    tags: ["时空", "烧脑", "美剧"],
    specials: ["s1"],
  },
  {
    id: "t008",
    title: "蝶影重重",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20espionage%20drama%20poster%20of%20an%20elegant%20woman%20in%20a%20dark%20alley%20holding%20secrets%2C%20deep%20navy%20and%20muted%20orange%20color%20grading%2C%20tense%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t008&orientation=portrait",
    year: 2024,
    rating: 8.2,
    region: "中国大陆",
    genres: ["谍战", "悬疑"],
    director: "柳云龙",
    actors: ["孙俪", "于和伟"],
    language: "汉语普通话",
    synopsis: "民国乱世，一位表面柔弱的女子潜伏于敌人内部，在刀尖上行走的岁月里，用智慧与信念守护着一份关乎胜利的机密。",
    updateTime: "2026-10-09",
    episodes: 32,
    views: 467000,
    tags: ["谍战", "民国", "女性"],
    specials: ["s4"],
  },
  {
    id: "t009",
    title: "京城往事",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20chinese%20period%20drama%20poster%20of%20old%20beijing%20hutong%20alley%20in%20autumn%20with%20traditional%20courtyards%2C%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20nostalgic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t009&orientation=portrait",
    year: 2023,
    rating: 8.9,
    region: "中国大陆",
    genres: ["历史", "剧情"],
    director: "郑晓龙",
    actors: ["陈宝国", "刘昊然"],
    language: "汉语普通话",
    synopsis: "以一座老四合院为轴心，横跨半个世纪的家族故事。时代洪流中，普通人的悲欢离合谱成一曲深情的京城挽歌。",
    updateTime: "2026-10-06",
    episodes: 48,
    views: 723000,
    tags: ["年代", "家族", "史诗"],
    specials: ["s3"],
  },
  {
    id: "t010",
    title: "深海救援队",
    type: "tv",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20poster%20of%20a%20rescue%20helicopter%20crew%20flying%20above%20stormy%20seas%2C%20deep%20navy%20and%20warm%20orange%20color%20grading%2C%20heroic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=qx-poster-t010&orientation=portrait",
    year: 2025,
    rating: 8.3,
    region: "中国大陆",
    genres: ["剧情", "职业"],
    director: "李雪",
    actors: ["彭于晏", "倪妮"],
    language: "汉语普通话",
    synopsis: "海上救援队队员们在每一次生死营救中直面风暴与湍流，用血肉之躯守护生命，也在一次次任务中重新理解了责任与爱。",
    updateTime: "2026-10-08",
    episodes: 28,
    views: 389000,
    tags: ["救援", "热血", "职业"],
    specials: ["s5"],
  },
];